import React from "react";
import { toast } from "react-toastify";
import { Offcanvas } from "react-bootstrap";
import { getUsers, changeUserWallet, updateUserCreditsReceived } from "store/users";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Joi from "joi-browser";
import { fetchNFT, ethToUSD } from "utils/externalApiCaller";
import _ from "lodash";
import ReactTooltip from "react-tooltip";
import Amplify, { Auth, Storage } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";
import userIcon from "include/images/user.png";
import plusIcon from "include/images/plus-1.svg";
import ethIcon from "include/images/eth-icon.svg";
import deleteIcon from "include/images/delete-icon.svg";

//  Components
import Form from "common/form/form";
import NextButton from "common/form/submitButton";
import AlertSuccess from "common/alert/alertSuccess";
import AlertError from "common/alert/alertError";

class AddFlyer extends Form {
  state = {
    loading: false,
    data: {
      walletAddress: "",
    },
    errors: {},
    loadingCredits: false,
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal !== prevProps.showModal) {
      this.clearData();
    }
  };
  doSubmit = (e) => {
    const errors = structuredClone(this.state.errors);
    const data = structuredClone(this.state.data);
    if (!data.walletAddress) {
      errors.walletAddress = "Rewards cannot be 0";
      return this.setState({ errors });
    }
    this.setState({ loadingCredits: true });
    const payLoad = {
      walletAddress: data.walletAddress,
    };
    this.props.changeUserWallet(payLoad, this.props.user?.id, (addCreditsResponse) => {
      this.setState({
        loadingCredits: false,
      });
      if (addCreditsResponse.status === 200) {
        toast(<AlertSuccess message="Information Saved" />, {
          containerId: 1,
        });
        this.props.toggleModal();
        this.clearData();
      } else {
        toast(<AlertError message={addCreditsResponse.data && addCreditsResponse.data.message} />, {
          containerId: 1,
        });
      }
    });
  };
  schema = {
    walletAddress: Joi.alternatives()
      .try(Joi.string(), Joi.number())
      .required()
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "any.empty":
              err.message = "Reward is required.";
              break;
          }
        });
        return errors;
      }),
  };
  clearData = () => {
    this.setState({
      loading: false,
      data: { walletAddress: "" },
      errors: {},
      loadingCredits: false,
    });
  };

  render() {
    const { user } = this.props;
    return (
      <Offcanvas
        className={"offcanvas offcanvas-end custom-offcanvas-pannel half-width-modal"}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="rewardPannel"
        placement="right"
        name="rewardPannel"
        backdrop={true}
      >
        <Offcanvas.Header className="offCanvas-header-2">
          <div>
            <h5>Add Wallet</h5>
            <div className="td-img-group d-flex align-items-start m-top-2">
              <div className="round-img m-right-2">
                {user.image ? (
                  <img src={process.env.REACT_APP_CDN + user.image.small} alt="" />
                ) : (
                  <img src={userIcon} alt="" />
                )}
              </div>
              {user.userName}
              <br />
              {user.email}
            </div>
          </div>
          <div
            className="btn_close pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.props.toggleModal}
          >
            <img src={closeIcon} alt="" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-check-outer">
            <div className="new-form-group">
              <table className="table large-table flyer-table">
                <thead>
                  <tr>
                    <th>Wallet Address</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="flyer-table">
                    <td>
                      <input
                        name="walletAddress"
                        type={"text"}
                        value={this.state.data.walletAddress}
                        className={`form-control ${
                          this.state.errors.walletAddress && this.state.errors.walletAddress && "error"
                        }`}
                        onChange={(e) => {
                          this.setState({ data: { walletAddress: e.target.value } });
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <NextButton
            classData="btn btn-default btn-block h-100"
            label="Save"
            loading={this.state.loadingCredits}
            handleSubmit={this.handleSubmit}
          />
        </div>
      </Offcanvas>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  changeUserWallet: (data, id, callback) => dispatch(changeUserWallet(data, id, callback)),
  updateUserCreditsReceived: (payLoad) => dispatch(updateUserCreditsReceived(payLoad)),
});
const mapStateToProps = (state) => ({
  getUsers: getUsers(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddFlyer));
